import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var TemplateReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default TemplateReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/Templates/TemplateReduxProps.ts
// module id = 492
// module chunks = 0